<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <form
        class="form-horizontal "
        role="form"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group form-inline d-flex justify-content-center">
              <label
                for="start_date"
                class="control-label mr-3"
              >Start Date</label>
              <div class="mr-3">
                <date-picker
                  v-model="start_date"
                  valueType="format"
                ></date-picker>
              </div>

              <label
                for="end_date"
                class="control-label mr-3"
              >End Date</label>
              <div class="mr-3">
                <date-picker
                  v-model="end_date"
                  valueType="format"
                ></date-picker>
              </div>
              <b-button
                variant="primary"
                @click.prevent="searchData"
                class="gobutton"
              >Go!</b-button>
            </div>
          </div>
        </div>
      </form>
      <div class="col-md-12 mt-3">
        <p class="text-center h3">Grand Total: {{ grandtotalprice }}</p>
        
      </div>

      <div class="col-md-12 mt-3">
        <b-container fluid>
          <!-- User Interface controls -->
          <hr />
          <b-row>
            <b-col
              lg="4"
              class="my-1"
            >
              <b-form-group
                label="Filter"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                    >Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              lg="6"
              class="my-1"
            >
              <b-form-group
                label="Filter On"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                description=""
                class="mb-0"
              >
                <b-form-checkbox-group
                  v-model="filterOn"
                  class="mt-1"
                >

                  <b-form-checkbox value="payment_type">Payment</b-form-checkbox>
                  <b-form-checkbox value="product_type">Type</b-form-checkbox>
                  <b-form-checkbox value="package">Package</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col
              sm="4"
              md="4"
              class="my-1"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>

          <!-- Main table element -->
          <b-table
            show-empty
            striped
            hover
            :items="items"
            :fields="fields"
            :tbody-tr-class="rowClass"
            :current-page="currentPage"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :data-filter-control=true
            :busy="loading"
            v-model="visibleRows"
          >

            <template v-slot:table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(ref_number)="row">
              <a :href="
                  $baseURL + '/api/purchases/generatereceipt/' + row.item.id
                ">{{ row.item.ref_number }}</a>
            </template>

            <template v-slot:cell(member.cardid)="row">
              <a
                href="#"
                @click.prevent="
                  $router.push({
                    name: 'MemberHome',
                    params: { id: row.item.member.id },
                  })
                "
              >{{ row.item.member.cardid }}</a>
            </template>

            <template v-slot:cell(package)="row">
              <div v-if="row.item.memberpackage!=null">
                {{ row.item.memberpackage.package.type }}
                {{ row.item.memberpackage.package.duration }}
                <span v-if="row.item.subscription">[{{ row.item.subscription.paid }}/{{
                  row.item.subscription.total
                }}]</span>
                <span v-if="row.item.memberpackage.note">
                  <b-button
                    class="btn-sm btn-light infobtnpackage"
                    :id="`popover-${row.item.id}`"
                    variant="primary"
                  ><i class="fas fa-info-circle infopackage"></i></b-button>
                  <b-popover
                    :target="`popover-${row.item.id}`"
                    triggers="hover focus"
                    :content="row.item.memberpackage.note"
                  ></b-popover>
                </span>
              </div>
              <div v-else-if="row.item.productpurchase!=null">
                {{ row.item.productpurchase.product.name }}
              </div>
            </template>

            <template v-slot:cell(member_name)="row">
              {{ row.item.member.firstname }}
              {{ row.item.member.lastname }}
            </template>

            <template v-slot:cell(price_total)="row">
              <span v-if="row.item.status == 'DONE'">{{
                row.item.price_total
              }}</span>
              <span
                v-else
                class="voidtxt"
              >{{ row.item.price_total }}
                <span v-if="row.item.note">
                  <b-button
                    class="btn-sm btn-light infobtnpackage"
                    :id="`popover-${row.item.id}`"
                    variant="primary"
                  ><i class="fas fa-info-circle infopackage"></i></b-button>
                  <b-popover
                    :target="`popover-${row.item.id}`"
                    triggers="hover focus"
                    :content="row.item.note"
                  ></b-popover>
                </span>
              </span>
            </template>

            <template v-slot:cell(actions)="row">
              <b-button
                size="sm"
                @click.prevent="showModal(row.item)"
                variant="secondary"
                v-if="isAuthLv2 == true"
              >
                <i class="fas fa-pencil-alt"></i>
                
              </b-button>
              <b-button
                class="ml-2"
                size="sm"
                @click.prevent="unlocksubModal(row.item.id)"
                variant="secondary"
                v-if="isAuthLv2 == true && row.item.status!='VOID'"
              >
              <i class="fas fa-trash"></i>
                
              </b-button>
              
            </template>

            <template
              slot="bottom-row"
              slot-scope="data"
            >
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td>
                <h5>Subtotal</h5>
              </td>
              <td>
                <h4>{{ totalDiscount }}</h4>
              </td>
              <td>
                <h4>{{ totalTax }}</h4>
              </td>
              <td>
                <h4>{{ totalAll }}</h4>
              </td>
              <td />
            </template>
          </b-table>
        </b-container>
      </div>
    </div>
    <modals-container name="purchase_edit_modal" />
    <div>
      <b-modal
        id="cf-modal"
        title="Comfirm"
        @ok="handleOk"
      >
        <p class="my-4">Confirm Void Payment?</p>
        <textarea
          name="voidtxtarea"
          id="voidtxtarea"
          class="voidtxtarea"
          rows="2"
          v-model="voidreason"
        ></textarea>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { isAuthLv1, isAuthLv2 } from "./../js/utils/global.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { getDateFormat } from "./../js/utils/date.js";
import {
  packageTypeFull,
  packageDurationFull
} from "./../js/utils/datamanip.js";
import ReportSaleEdit from "./ReportSaleEdit.vue";
import Vue from "vue";
import VModal from "vue-js-modal";
Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: true } });
export default {
  data() {
    return {
      visibleRows: [],
      loading: false,
      items: null,
      start_date: new Date().toISOString().substring(0, 10),
      end_date: new Date().toISOString().substring(0, 10),
      grandtotalprice: 0,
      voidreason: null,
      currentSubId: null,
      fields: [
        {
          key: "ref_number",
          label: "Ref #",
          sortable: true
        },
        {
          key: "member.cardid",
          label: "mem ID"
        },
        {
          key: "member_name",
          label: "Name"
        },
        {
          key: "user.nickname",
          label: "Sold by"
        },
        {
          key: "sale_date",
          label: "Sale Date",
          sortable: true
        },
        {
          key: "payment_type",
          label: "Payment"
        },
        {
          key: "product_type",
          label: "Type"
        },
        {
          key: "package",
          label: "Package"
        },
        /*{
          key: "memberpackage.package.type",
          label: "Package",
        },
        {
          key: "memberpackage.package.duration",
          label: "Duration",
        },*/
        {
          key: "price_unit",
          label: "Price"
        },
        {
          key: "qty",
          label: "Qty"
        },
        {
          key: "discount",
          label: "Discount"
        },
        {
          key: "tax",
          label: "Tax"
        },
        {
          key: "price_total",
          label: "Total"
        },
        {
          key: "actions",
          label: "Action"
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 200,
      pageOptions: [200, 400],
      filter: null,
      //filterOn: ["member.cardid", "payment_type", "package"],
      filterOn: [],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      purchase: null
    };
  },
  components: {
    DatePicker
  },
  computed: {
    isAuthLv2,
    totalAll() {
      //return this.items.services.reduce(function(a, c){return a + Number((c.rate*c.qnty) || 0)}, 0)
      return this.visibleRows.reduce((accum, item) => {
        if (item.status == "VOID") {
          return accum;
        }
        return accum + parseFloat(item.price_total);
      }, 0.0);//*/
    },
    totalTax() {
      //return this.items.services.reduce(function(a, c){return a + Number((c.rate*c.qnty) || 0)}, 0)
      return this.visibleRows.reduce((accum, item) => {
        return accum + parseFloat(item.tax);
      }, 0.0);
    },
    totalDiscount() {
      //return this.items.services.reduce(function(a, c){return a + Number((c.rate*c.qnty) || 0)}, 0)
      return this.visibleRows.reduce((accum, item) => {
        return accum + parseFloat(item.discount);
      }, 0.0);
    },
    /*     start_date() {
      return getDateFormat(new Date());
    },
    end_date() {
      return getDateFormat(new Date());
    }, */
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {},
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.status === "VOID") {
        return "table-danger";
      } else if (item.price_total == 0) {
        return "table-primary";
      }
    },
    itemClick(item, index, target) {},
    async searchData() {
      if (this.start_date !== null && this.end_date !== null) {
        this.loading = true;
        await axios
          .post("/api/purchases/list", {
            from: this.start_date,
            to: this.end_date
          })
          .then(response => {
            //console.log(response.data);
            this.items = response.data;
            this.manipData(this.items);
            this.totalRows = this.items.length;
            //console.log(response.data);
            this.loading = false;
          });
      }
    },
    showModal(item) {
      //console.log(item);
      this.purchase = item;

      this.$modal.show(
        ReportSaleEdit,
        {
          //--- Component property
          purchase: this.purchase
          //selfmodal: this.$modal,
        },
        {
          //-- Modal Params
          draggable: false,
          height: "auto",
          scrollable: true,
          adaptive: true
        },
        {
          //-- Modal event listener
          "before-close": event => {
            //console.log(event);
            //console.log("this will be called before the modal closes");
            this.searchData();
          },
          "before-open": event => {
            //console.log("this will be called before the modal open");
          },
          closed: event => {}
        },
        {}
      ); //*/
    },
    manipData(items){
      this.grandtotalprice = 0;
      for(var i in items){
        if (items[i]['status'] != "VOID") {
          this.grandtotalprice += parseFloat(items[i]['price_total']);
        }
        
      }
      //console.log(this.grandtotalprice);
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.voidSale();
    },
    unlocksubModal(id) {
      this.currentSubId = id;
      this.$bvModal.show("cf-modal");
    },
    async voidSale() {
      this.loading = true;
      await axios
        .post("/api/purchases/void", {
          id: this.currentSubId,
          note: this.voidreason
        })
        .then(response => {
          //console.log("len " + response.data.data.length);
          //console.log(response.data);
          //console.log(this.packageArr);
          this.getPurchase();
        })
        .catch(function(error) {
          //console.log(error.response.data.errors);
          //if(error.response.data.errors.message =)
        })
        .finally(() => {
          this.$bvModal.hide("cf-modal");
          this.loading = false;
          this.currentSubId = null;
          this.voidreason = null;
          this.searchData();
        });
    },
    getPackageTypeFull(key) {
      return packageTypeFull[key];
    },
    getPackageDurationFull(key) {
      return packageDurationFull[key];
    },
    async getPdf(purchaseid) {
      await axios
        .post("/api/purchases/generatereceipt", {
          id: purchaseid
        })
        .then(response => {
          // console.log((this.items = response.data.data));
          //console.log(response.data);
          //this.loading = false;
        });
    }
  }
};
</script>
<style scoped>
.gobutton {
  width: 80px;
  font-weight: bold;
}
table {
  font-size: 0.9em;
}
.voidtxt {
  color: #f00;
  text-decoration: line-through;
}
.infopackage {
  font-size: 1.5em;
  color: #007bff;
}
.infobtnpackage {
  padding: 0;
  background-color: transparent;
  border-color: transparent;
}
</style>
